module.exports = __webpack_public_path__ + "static/media/SelfCompassionAndAcceptance.a354b58a.png";